import { Accordion, AccordionContent, AccordionPanel, AccordionTitle } from 'flowbite-react'
import { Accordion as AccordionData } from '@/payload-types'
import RenderRichTexComponent from '@/components/rich-text-render/richTextRender'
import clsx from 'clsx'

interface IProps {
  accordionData: AccordionData
}

export const AccordionPost = ({ accordionData }: IProps) => {
  const curAccordion = accordionData.accordion

  const accordionStyle = accordionData?.accordionStyle
  //Header colors
  const textColorActiveHeader = accordionStyle?.activeHeader?.color
    ? accordionStyle.activeHeader.color
    : 'gray-900'
  const bgColorActiveHeader = accordionStyle?.activeHeader?.backgroundColor
    ? accordionStyle.activeHeader.backgroundColor
    : 'gray-100'
  const textColorInactiveHeader = accordionStyle?.inactiveHeader?.color
    ? accordionStyle.inactiveHeader.color
    : 'gray-500 '
  const bgColorInactiveHeader = accordionStyle?.inactiveHeader?.backgroundColor

  //Body  colors
  const textColorActiveBody = accordionStyle?.activeBody?.color
    ? accordionStyle.activeBody.color
    : 'gray-600'
  const bgColorActiveBody = accordionStyle?.activeBody?.backgroundColor

  const curAccordionPane = curAccordion?.accordionPane ? curAccordion.accordionPane : []

  const ifJustOnePanel =
    curAccordionPane.length <= 1 ? 'rounded-lg' : 'first:rounded-t-lg last:rounded-b-lg'

  //Need to use the theme property of AccordionTitle, because that way we can apply the style to the built-in functionality when clicking the button.
  //Style based on Accordion's default theme.
  const customAccordionTitleTheme = {
    base: `flex w-full items-center justify-between p-5 text-left text-${textColorInactiveHeader} bg-${bgColorInactiveHeader} ${ifJustOnePanel}`,
    flush: {
      off: `hover:bg-${bgColorActiveHeader}`,
      on: 'bg-transparent',
    },
    open: {
      off: '',
      on: `bg-${bgColorActiveHeader} text-${textColorActiveHeader}`,
    },
  }

  const customAccordionContentTheme = {
    base: `p-5 ${ifJustOnePanel}`,
  }

  return (
    <div className={`pt-2`}>
      <Accordion collapseAll={true}>
        {curAccordionPane.map((item) => {
          return (
            <AccordionPanel key={item.id}>
              <AccordionTitle
                className={'headerAccordion'}
                as={'h3'}
                theme={customAccordionTitleTheme}
              >
                {item.header}
              </AccordionTitle>
              <AccordionContent
                theme={customAccordionContentTheme}
                className={clsx(
                  `text-${textColorActiveBody} bg-${bgColorActiveBody} richTextContentAccordion`,
                )}
              >
                <RenderRichTexComponent richTextField={item.richText} />
              </AccordionContent>
            </AccordionPanel>
          )
        })}
      </Accordion>
    </div>
  )
}

export default AccordionPost
